import { render } from "./GallerySlider.vue.js?vue&type=template&id=3513bc80!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./GallerySlider.vue?vue&type=template&id=3513bc80"
import script from "./GallerySlider.vue.js?vue&type=script&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./GallerySlider.vue?vue&type=script&lang=js"
export * from "./GallerySlider.vue.js?vue&type=script&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./GallerySlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"public/assets/youthletics/components/GallerySlider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3513bc80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3513bc80', __exports__)) {
    api.reload('3513bc80', __exports__)
  }
  
  module.hot.accept("./GallerySlider.vue.js?vue&type=template&id=3513bc80!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./GallerySlider.vue?vue&type=template&id=3513bc80", () => {
    api.rerender('3513bc80', render)
  })

}


export default __exports__